import React from 'react';
import { AutoComplete, Input, Segmented } from 'antd';
import { Search } from 'lucide-react';
import { useUserFilters, STATUS_OPTIONS } from './userActions.controller';

/** Search + status filter shown above the users table. */
export default function UserActions({ users, setRows }) {
    const { suggestions, searchValue, setSearchValue, status, onSearch, onStatusChange } = useUserFilters({ users, setRows });

    return (
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center">
            <AutoComplete
                value={searchValue}
                options={suggestions.map((value) => ({ value }))}
                onSearch={onSearch}
                onSelect={onSearch}
                onChange={(value) => setSearchValue(value)}
                className="w-full sm:w-72">
                <Input placeholder="Buscar usuario..." prefix={<Search className="text-surface-400" />} allowClear />
            </AutoComplete>

            <Segmented options={STATUS_OPTIONS} value={status} onChange={onStatusChange} />
        </div>
    );
}
